import { cn } from "@repo/utils";

export type ItemProps<T = void> = {
  id: string;
  label: string;
  icon?: React.ReactNode;
  onClick: (ctx: T) => void;
  disabled?: boolean | ((ctx: T) => boolean);
  show?: boolean | ((ctx: T) => boolean);
  destructive?: boolean;
};

export type EvaluatedItemProps = Omit<ItemProps, "disabled" | "show"> & {
  disabled?: boolean;
  show?: boolean;
};

type Props = {
  items: EvaluatedItemProps[];
  onClick: (item: EvaluatedItemProps) => void;
};

export const DropdownMenuItemList = ({ items, onClick }: Props) => {
  const visibleItems = items.filter((item) => item.show !== false);

  return (
    <>
      {visibleItems.map((item, index) => (
        <button
          data-allow-navigation
          key={item.id}
          type="button"
          onClick={() => onClick(item)}
          disabled={item.disabled}
          className={cn(
            "flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors",
            {
              "cursor-not-allowed opacity-50": item.disabled,
              "text-red-600 hover:bg-red-50": !item.disabled && item.destructive,
              "text-gray-700 hover:bg-gray-100": !item.disabled && !item.destructive,
              "border-b border-gray-100": index < visibleItems.length - 1 && !item.disabled,
            }
          )}
        >
          {item.icon && <span className="flex-shrink-0">{item.icon}</span>}
          <span className="flex-1">{item.label}</span>
        </button>
      ))}
    </>
  );
};
